import formatLongDate from '@UI/Helpers/formatLongDate';
import type DocumentView from '@UI/Store/Documents/Views/DocumentView';

/**
 * "{title} — {type} du {long date}", or "Document n° {id}" when the document is not in the loaded list.
 * The " — {type}" part is dropped when the type label is unknown.
 */
const formatDocumentReference = (
	document: DocumentView | null,
	documentId: number,
	typeLabel: string | null,
): string => {
	if (document === null) {
		return `Document n° ${documentId}`;
	}

	const typePart = typeLabel === null ? '' : ` — ${typeLabel}`;

	return `${document.title}${typePart} du ${formatLongDate(document.createdAt)}`;
};

export default formatDocumentReference;
